module.exports = __webpack_public_path__ + "img/file-easel-fill.1cb6fed3.svg";